// extracted by mini-css-extract-plugin
module.exports = {"blackAccentStyle":"accent-styles_blackAccentStyle__gPaE7"};